import React, { PropsWithChildren } from 'react'

import GridItem from './GridItem'
import { GridProps } from './Grid.model'
import { StyledGridContainer } from './Grid.styled'

interface GridComponent {
  (props: PropsWithChildren<GridProps>): React.ReactNode;
  Item?: typeof GridItem;
}

const Grid: GridComponent = ({ 
  alignContent,
  alignItems,
  alignSelf,
  children,
  gap,
  gridTemplateColumns,
  justifyContent,
  margin,
  maxHeight,
  minHeight,
  padding,
}) => (
  <StyledGridContainer
    alignContent={alignContent}
    alignItems={alignItems}
    alignSelf={alignSelf}
    data-testid="grid-container"
    gap={gap}
    gridTemplateColumns={gridTemplateColumns}
    justifyContent={justifyContent}
    margin={margin}
    maxHeight={maxHeight}
    minHeight={minHeight}
    padding={padding}
  >
    {children}
  </StyledGridContainer>
)

export default Grid
